import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-team-name.pcss';

export default class TTTeamName extends LitElement {
    static get properties() {
        return {
            team: String,
            number: String
        };
    }

    static get styles() {
        return [css];
    }

    render() {
        return html`${this.computeTeamName(this.team, this.number)}`;
    }

    computeTeamName(club, number) {
        if (number)
            return club + " " + number;
        return club;
    }

}

window.customElements.define('tt-team-name', TTTeamName);
